function toggleHeaderSearch (){
  const headerSearchTriggers = document.querySelectorAll('.js_toggle-header-search');
  const bodyEl = document.querySelector('body');
 
  headerSearchTriggers.forEach(trigger => {
    trigger.addEventListener('click', function(e) {
      e.preventDefault();
      bodyEl.classList.toggle('state__header-search-open');
    })
  });  
}

export default toggleHeaderSearch;